document.addEventListener('DOMContentLoaded', function() {
  const qtySelectors = document.querySelectorAll('[data-quantity-selector]');

  if (qtySelectors.length > 0) {
    for (let i = 0; i < qtySelectors.length; i++) {
      qtySelectors[i].addEventListener('change', updateQtySelectors);
      qtySelectors[i].addEventListener('keyup', updateQtySelectors);
    }
  }

  function updateQtySelectors(evt) {
    const target = evt.target;
    const id = target.getAttribute('data-id');
    let value = target.value;
    const maxValue = target.max;

    if (Number(value) > Number(maxValue)) {
      target.value = maxValue;
      value = maxValue;
    }

    const activeQtySelectors = document.querySelectorAll('.cart__qty-selector-' + id);
    if (activeQtySelectors.length > 0) {
      for (let i = 0; i < activeQtySelectors.length; i++) {
        activeQtySelectors[i].value = value;
      }
    }
  }
});
